import { render, staticRenderFns } from "./OperaShopInfoSeeWindow.vue?vue&type=template&id=becea612&scoped=true&"
import script from "./OperaShopInfoSeeWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopInfoSeeWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopInfoSeeWindow.vue?vue&type=style&index=0&id=becea612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becea612",
  null
  
)

export default component.exports